import { buildTokenHash, hashPassword, randomToken } from '../utils/crypto';

const RESET_WINDOW_HOURS = 6;

export const buildResetToken = async () => {
  const token = randomToken(24);
  const tokenHash = await buildTokenHash(token);
  const expiresAt = new Date(Date.now() + RESET_WINDOW_HOURS * 60 * 60 * 1000).toISOString();
  return { token, tokenHash, expiresAt };
};

export const buildPasswordHash = async (password) => {
  // TODO: Replace with bcrypt/argon2 in backend service.
  return hashPassword(password);
};

export const isResetTokenValid = ({ tokenHash, expiresAt }, candidateHash) => {
  if (!tokenHash || !candidateHash) return false;
  if (expiresAt && new Date(expiresAt) < new Date()) return false;
  return tokenHash === candidateHash;
};
